<!-- *************************************************************************
	TEMPLATE
	************************************************************************* -->

<template>
	<div class="container">
		<BRow class="topRowPadding">
			<BCol lg="7" md="auto">
				<img src="../../assets/validationFailed.svg" />
			</BCol>
			<!-- Incorrect Information -->
			<BCol v-if="incorrectInformation" lg="5" md="auto">
				<BRow>
					<BCol>
						<h2>{{ $t('incorrectInformationTitle') }}</h2>
					</BCol>
				</BRow>
				<BRow>
					<BCol>
						<p class="text_font">{{ $t('incorrectInformationMessage1') }}</p>
						<p class="text_font">
							{{ $t('incorrectInformationMessage2') }}
							<a href="#" @click="openPublicWebsite">{{ $t('publicFacingWebsiteLink') }}</a>
							{{ $t('incorrectInformationMessage3') }}
						</p>
					</BCol>
				</BRow>
			</BCol>
			<!-- Not Eligible -->
			<BCol v-if="notEligible" lg="5" md="auto">
				<BRow>
					<BCol>
						<h2>{{ $t('notEligibleTitle') }}</h2>
					</BCol>
				</BRow>
				<BRow>
					<BCol>
						<p class="text_font">{{ $t('notEligibleMessage1') }}</p>
					</BCol>
				</BRow>
			</BCol>
			<!-- Coverage Expired -->
			<BCol v-if="coverageExpired" lg="5" md="auto">
				<BRow>
					<BCol>
						<h2>{{ $t('coverageExpiredTitle') }}</h2>
					</BCol>
				</BRow>
				<BRow>
					<BCol>
						<p class="text_font">{{ $t('coverageExpiredMessage1') }}</p>
						<p class="text_font">
							{{ $t('coverageExpiredMessage2') }}
							<a href="#" @click="openPublicWebsite">{{ $t('publicFacingWebsiteLink') }}</a>
						</p>
					</BCol>
				</BRow>
			</BCol>
		</BRow>
	</div>
</template>
<!-- *************************************************************************
	SCRIPT
	************************************************************************* -->

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import IdMixin from '@/mixins/id';
import BaseButton from '@/components/common/base/auth/BaseButton.vue';
import BaseForm from '@/components/common/base/auth/BaseForm.vue';
import { BRow, BCol, BCard, BFormRow } from 'bootstrap-vue';

@Component({
	name: 'ValidateFailed',
	components: {
		BaseButton,
		BaseForm,
		BRow,
		BCol,
		BCard,
		BFormRow
	},
	props: {
		automationId: {
			type: String,
			required: true
		}
	},
	mixins: [IdMixin],
	beforeRouteEnter(to, from, next) {
		if (from.name != 'validate' && from.name != 'sign-in') {
			next(vm => {
				vm.$router.push('home');
			});
		} else {
			next();
		}
	}
})
export default class ValidationFailed extends Vue {
	incorrectInformation = this.$route.query.failureScenario === 'INVALID';
	notEligible = this.$route.query.failureScenario === 'undefined' || this.$route.query.failureScenario === 'NOT_ELIGIBLE';
	coverageExpired = this.$route.query.failureScenario === 'COVERAGE_EXPIRED';

	created() {
		console.log('failureScenerio: ' + this.$route.query.failureScenario);
		console.log('notEligible: ' + this.notEligible);
		console.log('incorrectInformation: ' + this.incorrectInformation);
		console.log('coverageExpired: ' + this.coverageExpired);
	}

	openPublicWebsite() {
		if (this.$store.state.i18n.locale === 'fr') {
			window.open(window.ENV.IFHP_PUBLIC_WEBSITE_URL_FR, '_blank');
		} else {
			window.open(window.ENV.IFHP_PUBLIC_WEBSITE_URL_EN, '_blank');
		}
	}
}
</script>
<style lang="scss" @scoped>
.container > div {
	margin-bottom: 1%;
	margin-left: 0;
	margin-right: 0;
}

.topRowPadding {
	padding-bottom: 100px;
	padding-top: 78px;
}

a {
	text-align: left;
	text-decoration: underline;
	font: normal normal bold 18px/24px Noto Sans;
	letter-spacing: 0px;
	color: #284162;
}
.text_font {
	text-align: left;
	font: normal normal normal 18px/24px Noto Sans;
	letter-spacing: 0px;
	color: #707070;
	opacity: 1;
}
h2 {
	text-align: left;
	font: normal normal bold 27px/33px Lato;
	letter-spacing: 0px;
	color: #333333;
	opacity: 1;
}

@media (max-width: 800px) {
	img {
		max-width: 300px;
	}
}
</style>

<!-- *************************************************************************
	TRANSLATIONS
	************************************************************************* -->

<i18n>
{
	"en": {
		"incorrectInformationTitle": "Verification Failed",
		"incorrectInformationMessage1": "We were unable to complete your account. This is due to your profile information being invalid. ",
		"incorrectInformationMessage2": "Please refer to the beneficiary handbook available on the ",
		"incorrectInformationMessage3": " for more information regarding registration criteria.",
		"publicFacingWebsiteLink": "IFHP public facing website",
		"notEligibleTitle": "Verification Failed",
		"notEligibleMessage1": "We'd like to inform you that there's been an update to your Interim Federal Health Program coverage. Please contact Immigration, Refugees and Citizenship Canada directly for more information.",
		"coverageExpiredTitle": "Coverage Expired",
		"coverageExpiredMessage1": "mpor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco. mpor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco.",
		"coverageExpiredMessage2": "For more information go to the "
	},
	"fr": {
		"incorrectInformationTitle": "Échec de la vérification",
		"incorrectInformationMessage1": "Nous n’avons pas pu valider votre compte, soit parce que les renseignements de votre profil ne sont pas exacts. ",
		"incorrectInformationMessage2": "Pour obtenir de plus amples renseignements sur les exigences d’inscription, veuillez consulter le manuel d’information des bénéficiaires disponible sur le ",
		"incorrectInformationMessage3": " ",
		"publicFacingWebsiteLink": "site Web public du PFSI.",
		"notEligibleTitle": "Échec de la vérification",
		"notEligibleMessage1": "Nous souhaitons vous informer que votre couverture du Programme fédéral de santé intérimaire a été mise à jour. Pour en savoir plus, communiquez directement avec Immigration, Réfugiés et Citoyenneté Canada.",
		"coverageExpiredTitle": "Coverage Expired [FR]",
		"coverageExpiredMessage1": "mpor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco. mpor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco. [FR]",
		"coverageExpiredMessage2": "For more information go to the [FR]"
		}
}
</i18n>
